import { firebase } from "../firebase/firebase";

export const uploadItem = (image, description, ref) => {
  return () => {
    if (ref) {
      firebase
        .database()
        .ref("Reference")
        .push({
          image,
          description,
        })
        .then(() => {
          alert("Sikeres feltöltés!");
          location.reload();
        })
        .catch(err => {
          alert("Nem sikerült a feltöltés!" + err.message);
        });
    } else {
      firebase
        .database()
        .ref("Item")
        .push({
          image,
          description,
        })
        .then(() => {
          alert("Sikeres feltöltés!");
          location.reload();
        })
        .catch(err => {
          alert("Nem sikerült a feltöltés!" + err.message);
        });
    }
  };
};



// WEBPACK FOOTER //
// ./src/actions/itemActions.js